interface ConversionRowProps {
  label: string
  planConversion: string
  factConversion: string
}

export function ConversionRow({ label, planConversion, factConversion }: ConversionRowProps) {
  return (
    <tr className="bg-purple-50/50">
      <td className="p-2 pl-12 text-xs text-muted-foreground italic">↳ {label}</td>
      <td className="p-2 text-right font-mono text-xs text-muted-foreground">{planConversion}</td>
      <td className="p-2 text-right font-mono text-xs text-muted-foreground">{factConversion}</td>
      <td className="p-2 text-right font-mono text-xs text-muted-foreground">{planConversion}</td>
      <td className="p-2 text-right font-mono text-xs text-muted-foreground">{factConversion}</td>
      <td className="p-2 text-center text-muted-foreground">-</td>
    </tr>
  )
}
